'use strict';

var createEnum = require('../enums/createEnum');

module.exports = createEnum(['INDIA_ONLY', 'NOT_INDIA']);